import React, { useState } from 'react';
// Import Link if using React Router for navigation
// import { Link } from 'react-router-dom';

const  MedicalDemoSimulator = () => {
    const [feedback, setFeedback] = useState(null); // { title: string, text: string, class: string } | null

    // Navigation Links (Consider replacing with React Router <Link> components if used internally)


    const chooseOption = (choice) => {
        let newFeedback = {};
        let feedbackClass = '';

        switch(choice) {
            case 'patient1':
                newFeedback = {
                    title: "Immediate Priority",
                    text: "Correct. This patient has a severe, life-threatening injury that is still treatable (airway/breathing issue). They fall into the 'immediate' or 'red' category of triage, requiring your attention first to save their life."
                };
                feedbackClass = "border-green-500 bg-green-100 text-green-900";
                break;
            case 'patient2':
                newFeedback = {
                    title: "Delayed Care",
                    text: "Incorrect. While this patient is in pain, their injuries (broken bones) are not immediately life-threatening. They would be triaged into the 'delayed' or 'yellow' category, meaning they can wait for care until the most critical patients are stabilized."
                };
                feedbackClass = "border-yellow-500 bg-yellow-100 text-yellow-900";
                break;
            case 'patient3':
                newFeedback = {
                    title: "Minor Injuries",
                    text: "Incorrect. This patient is considered 'minor' or 'green' in triage (walking wounded). They can be treated last, as their injuries do not pose a serious risk to their life."
                };
                feedbackClass = "border-blue-500 bg-blue-100 text-blue-900";
                break;
            case 'patient4':
                newFeedback = {
                    title: "Deceased or Expectant",
                    text: "Incorrect. In a multi-casualty incident, a patient with no pulse or breathing is generally considered 'expectant' or 'black.' With limited resources, efforts are focused on patients who have a higher chance of survival."
                };
                feedbackClass = "border-red-500 bg-red-100 text-red-900";
                break;
            default:
                 newFeedback = { title: "Error", text: "Invalid choice selected." };
                 feedbackClass = "border-gray-500 bg-gray-100 text-gray-900";
        }
        setFeedback({ ...newFeedback, class: feedbackClass });
    };

    // Style for the main container to apply background
    const backgroundStyle = {
        backgroundImage: "url('https://images.unsplash.com/photo-1579684385127-1ef15d508118?q=80&w=2940&auto=format&fit=crop')",
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundAttachment: 'fixed'
    };


    return (
        <div className="flex flex-col items-center justify-center min-h-screen p-4" style={backgroundStyle}>
            {/* Header Navigation */}
            <header className="absolute top-4 w-full text-center z-10">
            
            </header>

            <div className="bg-gray-900/80 backdrop-blur-sm shadow-2xl rounded-3xl p-8 max-w-2xl w-full text-center text-white my-auto"> {/* Added my-auto for vertical centering */}
                {/* Header Banner */}
                <div className="bg-red-800 rounded-t-3xl -mt-8 -mx-8 px-8 py-6 shadow-xl border-b-4 border-white">
                    <h2 className="text-xl font-bold tracking-wide">Medical Triage Simulator</h2>
                </div>

                {/* Simulator Content */}
                <div className="p-4 mt-6">
                    <h1 className="text-3xl font-extrabold text-white mb-2">🚨 Multiple Casualties Arriving</h1>
                    <p className="text-lg text-gray-300 mb-6">
                        You are the Lead Physician in the ER. An ambulance is arriving with four victims from a major traffic incident.
                    </p>

                    <div className="bg-gray-800 p-6 rounded-2xl shadow-inner text-left mb-6 border-l-4 border-white">
                        <h3 className="text-xl font-bold text-red-400 mb-2">⚠️ Situation</h3>
                        <p className="text-gray-300 text-sm mb-4">
                            The paramedic gives you a quick rundown. Based on the initial report, who do you treat FIRST?
                        </p>
                        <ul className="list-none space-y-2 text-sm"> {/* Use list-none for cleaner look */}
                            <li><span className="font-semibold text-yellow-300 inline-block w-20">Patient 1:</span> Unconscious, severe head trauma, breathing erratically. <span className="text-red-400 font-bold">(Immediate - Red)</span></li>
                            <li><span className="font-semibold text-blue-300 inline-block w-20">Patient 2:</span> Conscious, multiple broken bones, severe pain, stable vitals. <span className="text-yellow-400 font-bold">(Delayed - Yellow)</span></li>
                            <li><span className="font-semibold text-green-300 inline-block w-20">Patient 3:</span> Minor cuts/bruises, walking and talking. <span className="text-green-400 font-bold">(Minor - Green)</span></li>
                            <li><span className="font-semibold text-gray-400 inline-block w-20">Patient 4:</span> Unconscious, no breathing, no pulse. <span className="text-gray-500 font-bold">(Expectant/Deceased - Black)</span></li>
                        </ul>
                    </div>

                    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                        <button onClick={() => chooseOption('patient1')} className="w-full py-3 px-6 bg-red-600 text-white font-bold rounded-xl text-lg shadow-lg hover:bg-red-700 transition-transform duration-200 transform hover:scale-105">
                            🩻 Triage Patient 1
                        </button>
                        <button onClick={() => chooseOption('patient2')} className="w-full py-3 px-6 bg-blue-600 text-white font-bold rounded-xl text-lg shadow-lg hover:bg-blue-700 transition-transform duration-200 transform hover:scale-105">
                            🩹 Triage Patient 2
                        </button>
                        <button onClick={() => chooseOption('patient3')} className="w-full py-3 px-6 bg-green-600 text-white font-bold rounded-xl text-lg shadow-lg hover:bg-green-700 transition-transform duration-200 transform hover:scale-105">
                            🚶 Triage Patient 3
                        </button>
                        <button onClick={() => chooseOption('patient4')} className="w-full py-3 px-6 bg-gray-600 text-white font-bold rounded-xl text-lg shadow-lg hover:bg-gray-700 transition-transform duration-200 transform hover:scale-105"> {/* Changed color */}
                            🚫 Triage Patient 4
                        </button>
                    </div>

                    {/* Result Display Area */}
                     <div id="result" className="mt-8 min-h-[100px]"> {/* Added min-height */}
                        {feedback && (
                            <div className={`p-6 rounded-2xl text-left shadow-xl border-l-4 ${feedback.class}`}>
                                <h4 className="text-xl font-bold mb-2">💡 {feedback.title}</h4>
                                <p className="font-semibold text-sm">{feedback.text}</p>
                            </div>
                        )}
                    </div>
                </div>
            </div>

            {/* Footer */}
            <footer className="w-full mt-auto py-4 text-white text-xs text-center font-light drop-shadow-lg bg-gray-900/30">
            
                <p>&copy; 2025 Aulice Academy.</p>
            </footer>
        </div>
    );
};

export default MedicalDemoSimulator;

